import axios from "axios";
import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/maps`;
import {
  GooglePlaceResult, MylobyPlace, NominatimPlace,
} from "@/interfaces/map";

const state = {};

const getters = {};

const mutations = {};

const searchByAddressNameNominatim = async (search: string): Promise<MylobyPlace[]> => {
  const countryCodes: string = ["fr", // France
    "it", // Italy
    "pt", // Portugal
    "de", // Germany
    "es", // Spain
    "ch", // Switzerland
    "be", // Belgium
  ].join(",");
  const url = `https://nominatim.openstreetmap.org/search?format=json&countrycodes=${countryCodes}&addressdetails=1&limit=10&q=${encodeURIComponent(search)}`;
  const res = await axios({ method: "get", url });
  const places: NominatimPlace[] = res.data || [];
  return places.map((nominatimPlace: NominatimPlace) => ({
    displayName: nominatimPlace.display_name,
    address: (nominatimPlace.address.house_number || nominatimPlace.address.leisure || "")
      + " " + (nominatimPlace.address.road || ""),
    latitude: parseFloat(nominatimPlace.lat),
    longitude: parseFloat(nominatimPlace.lon),
    city: nominatimPlace.address.town || nominatimPlace.address.city || nominatimPlace.address.municipality,
    country: nominatimPlace.address.country,
    zipcode: nominatimPlace.address.postcode,
  }));
};

const searchByAddressNameGoogle = async (search: string): Promise<MylobyPlace[]> => {
  const params = {
    input: search,
  };
  const res = await axiosInstance.get(baseUrl + "/google-findplacefromtext", { params });
  const places: GooglePlaceResult[] = res.data.places || [];
  return places.map((googlePlace: GooglePlaceResult): MylobyPlace => ({
    displayName: googlePlace.formattedAddress,
    address: googlePlace.postalAddress?.addressLines?.[0],
    latitude: googlePlace.location.latitude,
    longitude: googlePlace.location.longitude,
    city: googlePlace.postalAddress.locality,
    country: googlePlace.addressComponents.find((component) => component.types.includes("country"))?.longText,
    zipcode: googlePlace.postalAddress.postalCode,
  }));
};

const actions = {
  async searchByAddressName({ commit }, payload: {
    search: string, provider: string,
  }): Promise<MylobyPlace[]> {
    if (payload.provider === "GOOGLE") {
      return searchByAddressNameGoogle(payload.search)
        .catch((err) => {
          // console.error(err);
          return searchByAddressNameNominatim(payload.search);
        });
    } else if (payload.provider === "NOMINATIM") {
      return searchByAddressNameNominatim(payload.search);
    }
  },
};

export default {
  namespaced: true, state, getters, actions, mutations,
};
